import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { commercialsDashboard } from "../api/commercialsDashboard";
import { CommercialDataItem } from "../types";

export const useCommercialData = (type?: string) => {

    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(5);

    const changePage = (newPage: number) => {
        setPage(newPage);
    };

    const changeRowsPerPage = (newLimit: number) => {
        setPage(1);
        setLimit(newLimit);
    };

    const { data, isLoading, isError, error, isSuccess } = useQuery({
        queryKey: ["commercials-dashboard", page, limit, type],
        queryFn: () => commercialsDashboard.fetchCommercialData({ page, limit, type }),
    });

    return {
        data: isSuccess ? data.rows : {} as CommercialDataItem,
        pagination: isSuccess ? data.pagination : {},
        isLoading,
        isError,
        error,
        changePage,
        changeRowsPerPage
    };

};